import axios from "axios";

const state = {  
  inactivePagination: null,
  search: null,
  SortedBy: null,
  loader: false,
  inactive: null,
  page:1,
  total:0
};

const mutations = {
  setPagination(state, data) {
    state.inactivePagination = data;
  },
  setTotal(state, data) {
    state.total = data;
  },
  setPage(state, data) {
    state.page = data;
  },
  setSortedBy(state, data) {
    state.SortedBy = data;
  },
  setLoader(state, data) {
    state.loader = data;
  },
  setInactive(state, data) {
    state.inactive = data;
  },
  setErrorMessage(state, data) {
    state.errorMessage = data;
  },
  setSearch(state, data) {
    state.search = data;
  }
};

const actions = {
  setSerachValue({ commit }, data) {
    commit("setSearch", data);
  },
  setPageNum({ commit }, data) {
    commit("setPage", data);
  },
  setInactiveSortedBy({ commit }, data) {
    commit("setSortedBy", data);
  },
  getInactiveList({ commit, state }, data) {
    let url = "/v1/admin/inactive?";
    if (state.page !== null) {
      url += `page=${state.page}`;
    }
    if (state.search !== null && state.search !== "") {
      url += `&search=${state.search}`;
    }
    if (state.SortedBy !== null) {
      url += `&order_by=created_at&sorted_by=${state.SortedBy}`;
    }
    commit("setLoader", true);
    return axios.get(url)
      .then(res => {
        commit("setLoader", false);
        commit("setInactive", res.data.data.testkits.data);
        commit("setTotal", res.data.data.testkits.total);
        commit("setPagination", res.data.data.testkits.lastPage);
        //commit("setPendingKits", res.data.data.testkits.data);
        // commit("setKitStatus", res.data.data.kit_status);
      })
      .catch(error => {
        commit("setLoader", false);
        commit("setErrorMessage", true);
      });
  }
};

const getters = {
  getPagination() {
    return state.inactivePagination;  
  },
  getSortedBy() {
    return state.SortedBy;  
  },
  getInActiveLoader(state) {
    return state.loader;  
  },
  getInactive() {
    return state.inactive;
  },
  getPage() {
    return state.page;
  },
  getTotal() {
    return state.total;
  },
  
};

export default {
  state,
  mutations,
  actions,
  getters
};
